<template>
  <div>
    <b-navbar toggleable="md" type="dark" variant="dark" fixed="top">
      <b-navbar-brand href="#">blair adventures</b-navbar-brand>

      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav>
          <b-nav-item :to="{ name: 'adventures'}">adventures</b-nav-item>
          <b-nav-item :to="{ name: 'photos'}">pictures</b-nav-item>
          <b-nav-item :to="{ name: 'blairs'}">blairs</b-nav-item>
          <b-nav-item href="/route/">route</b-nav-item>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item :to="{name: 'adventure-create'}" v-if="canCreateAdventures">
            <BaseIcon name="plus"/>
          </b-nav-item>
          <b-nav-item :to="{name: 'profile'}">
            <BaseIcon name="user"/>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["canCreateAdventures"])
  }
};
</script>

<style scoped>
</style>
